import { ChevronDown, FileText, Loader2, LucideIcon, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { PdfMode } from "@/Api/gameBankSelections";

/** A partir de quantos bolões o PDF padrão demora e pode passar do tempo do servidor */
export const PDF_STANDARD_SLOW_BOLOES = 300;

/**
 * Botão de PDF com as duas formas de gerar (LOT-62): rápida (mesmo layout, desenhado direto) e padrão (HTML).
 */
export const PdfMenu = ({
  label,
  icon: Icon,
  loading,
  disabled,
  boloesCount,
  onSelect,
  className,
  size,
}: {
  label: string;
  icon: LucideIcon;
  loading: boolean;
  disabled?: boolean;
  boloesCount: number;
  onSelect: (mode: PdfMode) => void;
  className?: string;
  size?: "default" | "sm";
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button size={size} className={className} disabled={disabled || loading}>
        {loading ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Icon className="mr-1.5 h-4 w-4" />}
        {label}
        <ChevronDown className="ml-1.5 h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-72">
      <DropdownMenuItem onClick={() => onSelect("fast")} className="flex cursor-pointer items-start gap-2.5 py-2">
        <Zap className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
        <div>
          <p className="font-medium">PDF rápido</p>
          <p className="text-xs text-muted-foreground">Mesmo layout, sai em poucos segundos. Recomendado.</p>
        </div>
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => onSelect("standard")} className="flex cursor-pointer items-start gap-2.5 py-2">
        <FileText className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
        <div>
          <p className="font-medium">PDF padrão</p>
          <p className="text-xs text-muted-foreground">
            {boloesCount >= PDF_STANDARD_SLOW_BOLOES
              ? `Com ${boloesCount} bolões pode demorar ou falhar.`
              : "A forma de gerar de antes."}
          </p>
        </div>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
